export const AddCart = "addtocart";
export const RmoveCart = "removefromcart";
export const CartIncQty = "incresequantitycart";
export const CartDecQty = "decresequantitycart";
export const GetCart = "getcart";